document.addEventListener('DOMContentLoaded', () => {
  const initBannerTabs = (container = document) => {
    const bannerTabSections = container.querySelectorAll('.liv-image-with-banner-tab-parent');
    const initializationTargets = container.classList?.contains('liv-image-with-banner-tab-parent') ? [container] : bannerTabSections;

    initializationTargets.forEach((sectionRoot) => {
      const mainShopifySection = sectionRoot.closest('.shopify-section');
      const allTabTriggers = sectionRoot.querySelectorAll('.liv-tab-btn, .liv-mobile-tab-option');
      const mobileDropdownTrigger = sectionRoot.querySelector('.liv-mobile-tab-trigger');
      const mobileDropdownMenu = sectionRoot.querySelector('.liv-mobile-tab-dropdown');

      const switchBannerTab = (activeTabIndex) => {
        const targetIdx = parseInt(activeTabIndex);
        const desktopTabButtons = sectionRoot.querySelectorAll('.liv-tab-btn');
        let startSectionOffset = 0, targetSectionCount = 0;

        desktopTabButtons.forEach((tabButton, currentIndex) => {
          const sectionsInTab = parseInt(tabButton.dataset.count || 0);
          if (currentIndex < targetIdx) startSectionOffset += sectionsInTab;
          if (currentIndex === targetIdx) targetSectionCount = sectionsInTab;
        });

        // Update active classes for all tab triggers
        allTabTriggers.forEach(trigger => {
          const triggerIdx = parseInt(trigger.dataset.index);
          trigger.classList.toggle('active', triggerIdx === targetIdx);
        });

        // Update active classes for banner items (images/headings)
        sectionRoot.querySelectorAll('.liv-banner-item').forEach(bannerItem => {
          const itemIdx = parseInt(bannerItem.dataset.index);
          bannerItem.classList.toggle('active', itemIdx === targetIdx);
        });

        // Show/Hide sibling sections based on range
        if (mainShopifySection) {
          let currentSibling = mainShopifySection.nextElementSibling, siblingIndex = 0;
          while (currentSibling && !currentSibling.querySelector('.liv-image-with-banner-tab-parent')) {
            if (currentSibling.classList.contains('shopify-section')) {
              const isWithinRange = (siblingIndex >= startSectionOffset && siblingIndex < startSectionOffset + targetSectionCount);
              currentSibling.style.display = isWithinRange ? 'block' : 'none';
              siblingIndex++;
            }
            currentSibling = currentSibling.nextElementSibling;
          }
        }

        // Update Mobile Dropdown text and UI
        const activeOption = sectionRoot.querySelector(`.liv-mobile-tab-option[data-index="${targetIdx}"]`);
        if (activeOption && mobileDropdownTrigger) {
          sectionRoot.querySelector('.liv-current-tab-text').textContent = activeOption.textContent.trim();
          mobileDropdownMenu?.classList.remove('open');
          mobileDropdownTrigger.classList.remove('active');
        }
      };

      // Event Listeners for Tab Switching
      allTabTriggers.forEach(trigger => {
        trigger.onclick = () => switchBannerTab(trigger.getAttribute('data-index'));
      });

      // Mobile Dropdown Toggle Logic
      if (mobileDropdownTrigger) {
        mobileDropdownTrigger.onclick = (event) => {
          event.stopPropagation();
          mobileDropdownMenu?.classList.toggle('open');
          mobileDropdownTrigger.classList.toggle('active');
        };
      }

      // Initial Default Activation
      const defaultActiveTab = sectionRoot.querySelector('.liv-tab-btn.active') || allTabTriggers[0];
      if (defaultActiveTab) switchBannerTab(defaultActiveTab.getAttribute('data-index') || 0);
    });
  };

  // Run initial setup
  initBannerTabs();

  // Close dropdowns on outside click
  document.addEventListener('click', () => {
    document.querySelectorAll('.liv-mobile-tab-dropdown').forEach(menu => menu.classList.remove('open'));
    document.querySelectorAll('.liv-mobile-tab-trigger').forEach(trigger => trigger.classList.remove('active'));
  });

  // Theme Editor Sync
  document.addEventListener('shopify:section:load', event => initBannerTabs(event.target));
  document.addEventListener('shopify:block:select', event => {
    const parentRoot = event.target.closest('.liv-image-with-banner-tab-parent');
    parentRoot?.querySelector(`.liv-tab-btn[data-index="${event.target.dataset.index}"]`)?.click();
  });
});